import workflowService from '@/services/workflow';
import { formatTimeAgo } from '@/api/notifications';

function requestApprovalCenter(config) {
  return workflowService(config);
}

export function mapApprovalToItem(approval) {
  const nextNodeName = approval.nextNodeName || '';
  return {
    id: approval.approvalExecutionId,
    workflowName: approval.workflowName || '',
    patientName: approval.patientName || '',
    patientId: approval.patientId,
    description: approval.description || '',
    nextNodeName,
    nextNodeSubtype: approval.nextNodeSubtype || '',
    timeAgo: formatTimeAgo(approval.startedAt),
    expiresAt: approval.expiresAt,
    workflowInstanceId: approval.workflowInstanceId,
    promptTitle: nextNodeName ? `Ready to ${nextNodeName}` : 'Ready to perform this action',
  };
}

export async function getPendingApprovalsApi() {
  const { data } = await requestApprovalCenter({
    url: '/workflows/approvals/pending',
    method: 'get',
  });
  return { data: data?.data || data };
}

export async function approveApprovalApi(approvalExecutionId, comment) {
  const body = {};
  if (comment) body.comment = comment;
  const { data } = await requestApprovalCenter({
    url: `/workflows/approvals/${approvalExecutionId}/approve`,
    method: 'put',
    data: body,
  });
  return { data: data?.data || data };
}

export async function rejectApprovalApi(approvalExecutionId, comment) {
  const body = {};
  if (comment) body.comment = comment;
  const { data } = await requestApprovalCenter({
    url: `/workflows/approvals/${approvalExecutionId}/reject`,
    method: 'put',
    data: body,
  });
  return { data: data?.data || data };
}
